<template>
<section class="bg-white border-bottom">	
	<div @click="toggleDetails()" class="text-gray-500 text-uppercase font-weight-bold px-4 py-25 bg-gray-100 cursor-pointer">
		<i class="fal fa-route fa-fw mr-1"></i> Your Routes <i class="fas" :class="showDetails == false ? 'fa-caret-right' : 'fa-caret-down'"></i>
	</div>
	<div  class="px-4 py-25">
		<div @click="toggleDetails()" class="d-flex pb-2" style="border-bottom: 1px solid #e4e5e6">
			<div class="flex-fill text-center">
				<span class="text-3xl leading-none">{{ activeRoutes.length ? activeRoutes.length : '0' }}</span><br>
				<span class="text-sm text-gray-500 leading-tight">Active Routes</span>
			</div>
			
			<div class="flex-fill text-center" style="line-height:24px">
				<span class="text-3xl leading-none">{{ completedRoutes.length  ? completedRoutes.length : '0' }}</span><br>
				<span class="text-sm text-gray-500 leading-tight">Recently Completed</span>
			</div>
		</div>

		<div class="pt-2 pb-2" v-if="showDetails" style="border-bottom:1px solid #e4e5e6">
			<div v-if="options.routes.length < 1">
				No routes found.
			</div>

			<div class="py-2" v-else v-for="route in activeRoutes.slice(-5)">
				<div class="d-flex">
					<router-link :to="{ name: 'routes.show', params: { id: route.id } }" class="flex-grow-1">{{ route.title }}</router-link>
					<div class="text-right">
						<span class="text-right">
							<strong v-if="route.visits">{{ Math.floor((route.progress/100) * route.visits.length) }}</strong>
							<span class="text-gray-500">/ {{ route.visits ? route.visits.length : '0' }} visits</span>
						</span>
					</div>
				</div>
				<div class="progress progress-xs">
					<div class="progress-bar" :class="moment(route.complete_by) < current ? '' : 'bg-success'" role="progressbar" :style="'width:' + route.progress + '%'" :aria-valuenow="route.progress" aria-valuemin="0" aria-valuemax="100"></div>
				</div>
			</div>
		</div>
		<div class="d-flex pt-2 pb-1 align-items-baseline">
			<div class="flex-grow-1 text-gray-500 font-weight-bold">
				<span v-if="showDetails && activeRoutes.length > 5">+{{ activeRoutes.length - 5 }} more</span>
			</div>
			<router-link :to="{ name: 'routes.index' }" class="btn btn-sm btn-ghost-primary">Manage Routes</router-link>
		</div>
	</div>
</section>
</template>



<script>
	import { mapState } from 'vuex'; 

	export default {
		data () {
			return {
				routes: {},
				current: moment(),
				showDetails: false,
				dataLoaded: false,
			}
		},

		created() {
		},

		methods: {
			toggleDetails() {
				this.showDetails = !this.showDetails;
			},					
		},

		computed: {
			...mapState(['options']),

        	activeRoutes() {
        		const filtered_routes = [];
				Object.keys(this.options.routes).forEach(key => {
					if (this.options.routes[key].status <= 1 || moment(this.current).diff(this.options.routes[key].ended_on, 'days') < 30) {
						filtered_routes.push(this.options.routes[key]);
					}						
				});
	    		return filtered_routes;

    		},

        	completedRoutes() {		
        		const filtered_routes = [];
				Object.keys(this.options.routes).forEach(key => {
					if (this.options.routes[key].status == 2 || moment(this.current).diff(this.options.routes[key].ended_on, 'days') < 30) {
						filtered_routes.push(this.options.routes[key]);
					}						
				});
	    		return filtered_routes;
    		},
       		     		
		}

	}

</script>

<style>
</style>